(function() {
  if (window.ztgWidgetConfig) return;

  var scriptSrc = 'https://ztgrowth.com.br/t/widget-loader.js';

  if (document.querySelector('script[src="' + scriptSrc + '"]')) return;

  window.ztgWidgetConfig = {
    companyHash: 'g65pe',
    apiBase: 'https://ztgrowth.com.br/',
    autoLoad: true
  };

  var s = document.createElement('script');
  s.src = scriptSrc;
  s.async = true;

  (document.head || document.body).appendChild(s);
})();
